import axios from 'axios';

export default {
  async getAutoQuotationContract(chave) {
    try {
      const response = await axios.get(
        `${
          process.env.VUE_APP_API_VIDA_URL
        }/contracts/auto/quotation/${encodeURIComponent(chave)}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getAutoProposalContract(chave) {
    try {
      const response = await axios.get(
        `${
          process.env.VUE_APP_API_VIDA_URL
        }/contracts/auto/proposal/${encodeURIComponent(chave)}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getLifeContract(chave) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/contracts/life/${encodeURIComponent(
          chave,
        )}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getAutoEndorsementContract(chave) {
    try {
      const response = await axios.get(
        `${
          process.env.VUE_APP_API_VIDA_URL
        }/contracts/auto/endorsement/${encodeURIComponent(chave)}`,
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
